export default class ProdutoCarregamentoViewModel {
    constructor () {
        this.NomeProduto = undefined;
        this.CondicaoPagamento = undefined;
        this.QuantidadeTotal = undefined;
        this.ValorUnitario = undefined;
        this.ValorTotalSemIPI = undefined;
        this.DatasCarregamento = undefined;
        this.CodigoPedidoDefinicao = '';
        this.ObservacaoDefinicao = '';
        this.DefinicaoPedido = 0
        this.HouveAlteracaoDataCarregamento = false;
        this.Observacao = undefined;
        this.ClienteOrdemCompra = undefined;     
        this.ValorTotalSemIPIFormatado = undefined;  
        this.CodigoAcesso = undefined;

    }
}